export default {
  BASE_URL: '/sob/ProdCountManage',
  api: [
    {
      name: 'complexCount',
      method: 'POST',
      desc: '综合数据',
      path: '/complexCount'
    },
    {
      name: 'complexList',
      method: 'POST',
      desc: '综合列表',
      path: '/complexList'
    },
    {
      name: 'expComplexList',
      method: 'POST',
      desc: '导出列表',
      path: '/expComplexList'
    },
    {
      name: 'skuList',
      method: 'POST',
      desc: 'SKU统计',
      path: '/skuList'
    },
    {
      name: 'getSkuEChartData',
      method: 'POST',
      desc: 'SKU统计视图',
      path: '/getSkuEChartData'
    },
    {
      name: 'expSkuList',
      method: 'POST',
      desc: 'SKU导出',
      path: '/expSkuList'
    },
    {
      name: 'brandList',
      method: 'POST',
      desc: '品牌列表',
      path: '/brandList'
    },
    {
      name: 'expBrandList',
      method: 'POST',
      desc: '品牌导出',
      path: '/expBrandList'
    },
    {
      name: 'purchaseList',
      method: 'POST',
      desc: '采购商列表',
      path: '/purchaseList'
    },
    {
      name: 'expPurchaseList',
      method: 'POST',
      desc: '采购商导出',
      path: '/expPurchaseList'
    },
    {
      name: 'supportList',
      method: 'POST',
      desc: '供应商列表',
      path: '/supportList'
    },
    {
      name: 'expSupportList',
      method: 'POST',
      desc: '供应商列表导出',
      path: '/expSupportList'
    },
    {
      name: 'projList',
      method: 'POST',
      desc: '项目列表',
      path: '/projList'
    },
    {
      name: 'expProjList',
      method: 'POST',
      desc: '项目导出',
      path: '/expProjList'
    },
    {
      name: 'complexOtherData',
      method: 'POST',
      desc: '综合数据统计视图',
      path: '/complexOtherData'
    },
    {
      name: 'expList',
      method: 'POST',
      desc: '导出excel表格',
      path: '/expList'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/product.js